import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Fade } from '../Fade';
import styles from './OtpInput.css';

const cx = classnames.bind(styles);

const CODE_LENGTH = 6;

function OtpInput({
    onComplete,
    onErrorClear,
    errorText,
    infoText,
    isAutoFocus = true,
    isLoading = false,
    isDisabled = false,
    value = ''
}) {
    const [inputValue, setInputValue] = useState('');
    const inputRef = useRef(null);

    useEffect(() => {
        if (isAutoFocus) inputRef.current?.focus();
    }, [isAutoFocus]);

    useEffect(() => {
        if (value !== '') return;
        setInputValue('');
        inputRef.current?.focus();
    }, [value]);

    function handleKeyDown(e) {
        if (e.key === 'Enter') e.preventDefault();
    }

    function handleChange(e) {
        const raw = e.target.value.replace(/\D/g, '').slice(0, CODE_LENGTH);

        setInputValue(raw);
        onErrorClear?.();
        if (raw.length === CODE_LENGTH) onComplete?.(raw);
    }

    return (
        <div className={styles.root}>
            <input
                ref={inputRef}
                className={cx('input', { error: Boolean(errorText), loading: isLoading, disabled: isDisabled })}
                type='text'
                name='otp'
                id='otp'
                inputMode='numeric'
                pattern='[0-9]*'
                maxLength={CODE_LENGTH}
                autoComplete='one-time-code'
                value={inputValue}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                disabled={isDisabled}
            />
            {Boolean(errorText) && (
                <Fade duration={200}>
                    <p className={styles.alert}>{errorText}</p>
                </Fade>
            )}
            {Boolean(infoText) && !errorText && (
                <p className={styles.info}>{infoText}</p>
            )}
        </div>
    );
}

OtpInput.propTypes = {
    onComplete: PropTypes.func,
    onErrorClear: PropTypes.func,
    errorText: PropTypes.string,
    infoText: PropTypes.string,
    isAutoFocus: PropTypes.bool,
    isLoading: PropTypes.bool,
    isDisabled: PropTypes.bool,
    value: PropTypes.string
};

export {
    OtpInput
};
